import React, { useEffect, useState, useRef } from "react";
import { Autoplay, EffectFade } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/bundle';

function FsSwiper(props) {
  const { } = props;

  return <>
      <Swiper
       modules={[Autoplay, EffectFade]}
      spaceBetween={0}
      slidesPerView={1}
			autoplay = {{
				delay: 3000,
      }}
      effect= {'fade'}
      loop
    >
      <SwiperSlide>
        <div className="first-screen__card">
          <div className="first-screen__card-img">
            <picture>
              <source srcSet="/img/first-screen-1-mob.png 1x, /img/first-screen-1-mob@2x.png 2x" media="(max-width: 625px)"/> 
              <img src="/img/first-screen-1.png"
              srcSet="/img/first-screen-1.png 1x, /img/first-screen-1@2x.png 2x"
              alt="bg" className="img"/>
            </picture>
          </div>
          <h1 className="first-screen__card-title">15 лет в ритме <span>Авито</span></h1>
          <p className="first-screen__card-description">Как&nbsp;с&nbsp;одного стола началась
            история многомиллионного бизнеса с&nbsp;офисами по&nbsp;всей стране</p>
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div className="first-screen__card">
          <div className="first-screen__card-img">
            <picture>
              {/* <source srcSet="/img/first-screen-2-mob.png 1x, /img/first-screen-2-mob@2x.png 2x" media="(max-width: 625px)"/>  */}
              <img src="/img/first-screen-2.png"
              srcSet="/img/first-screen-2.png 1x, /img/first-screen-2@2x.png 2x"
              alt="bg" className="img"/>
            </picture>
          </div>
          <h1 className="first-screen__card-title">15 лет в ритме <span>Авито</span></h1>
          <p className="first-screen__card-description">Как&nbsp;с&nbsp;одного стола началась
            история многомиллионного бизнеса с&nbsp;офисами по&nbsp;всей стране</p>
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div className="first-screen__card">
          <div className="first-screen__card-img">
            <img src="/img/first-screen-3.png"
              srcSet="/img/first-screen-3.png 1x, /img/first-screen-3@2x.png 2x"
              alt="bg" className="img"/>
          </div>
          <h1 className="first-screen__card-title">15 лет в ритме <span>Авито</span></h1>
          <p className="first-screen__card-description">Как&nbsp;с&nbsp;одного стола началась
            история многомиллионного бизнеса с&nbsp;офисами по&nbsp;всей стране</p>
        </div>
      </SwiperSlide>
      <SwiperSlide>
       <div className="first-screen__card">
          <div className="first-screen__card-img">
            <img src="/img/first-screen-4.png"
              srcSet="/img/first-screen-4.png 1x, /img/first-screen-4@2x.png 2x"
              alt="bg" className="img"/>
          </div>
          <h1 className="first-screen__card-title">15 лет в ритме <span>Авито</span></h1>
          <p className="first-screen__card-description">Как&nbsp;с&nbsp;одного стола началась
            история многомиллионного бизнеса с&nbsp;офисами по&nbsp;всей стране</p>
        </div>
      </SwiperSlide>
    </Swiper>
  </>;
}

export default FsSwiper;
